import React from 'react';
import ReactMarkdown from 'react-markdown';
import './Terms.css';

const Terms = () => {
  const [terms, setTerms] = React.useState('');

  React.useEffect(() => {
    const termsContent = `# Termeni și Condiții - Antifurt QR

## 1. Acceptarea Termenilor și Condițiilor
Prin utilizarea aplicației **Antifurt QR**, utilizatorul este de acord cu termenii și condițiile de mai jos. Dacă nu sunteți de acord, vă rugăm să nu utilizați această aplicație.

## 2. Descrierea Serviciului
Antifurt QR este o aplicație destinată protejării obiectelor personale prin generarea de coduri QR unice, care permit identificarea și gestionarea statutului unui obiect.

## 3. Limitări și Responsabilități

### 3.1. Utilizarea corectă a aplicației
- Utilizatorii sunt responsabili pentru informațiile introduse în aplicație.
- Codurile QR trebuie utilizate doar pentru obiectele personale.

### 3.2. Limitări tehnice
- Aplicația nu garantează recuperarea obiectelor pierdute sau furate.
- Notificările și monitorizarea scanărilor depind de disponibilitatea conexiunii la internet.

### 3.3. Securitatea și confidențialitatea datelor
- Utilizatorii trebuie să păstreze în siguranță seed-ul generat pentru fiecare obiect.
- Antifurt QR nu își asumă responsabilitatea pentru pierderea sau compromiterea seed-ului.

## 4. Răspundere și Garanții
- Aplicația este furnizată "așa cum este", fără garanții explicite sau implicite.
- Antifurt QR nu își asumă responsabilitatea pentru utilizarea incorectă a serviciului sau pentru deciziile luate de utilizatori în urma utilizării aplicației.

## 5. Confidențialitate și Date Personale
- Datele utilizatorilor sunt protejate conform legislației privind protecția datelor.
- Antifurt QR poate stoca informații despre scanările codurilor QR, cum ar fi IP-ul dispozitivului, în scop de monitorizare și securitate.
- Utilizatorii au dreptul să își șteargă datele din aplicație în orice moment.

## 6. Încălcarea Termenilor și Condițiilor
- Orice utilizare abuzivă a aplicației poate duce la suspendarea sau interzicerea accesului la serviciu.
- Utilizatorii care introduc informații false sau care utilizează aplicația pentru activități ilegale pot fi raportați autorităților.

## 7. Modificarea Termenilor
- Antifurt QR își rezervă dreptul de a modifica acești termeni și condiții în orice moment.
- Continuarea utilizării aplicației după actualizare constituie acceptarea noilor termeni.

## 8. Contact
Pentru întrebări sau sesizări, ne puteți contacta la **contact@antifurt.app**.

---
Prin utilizarea aplicației **Antifurt QR**, confirmați că ați citit, înțeles și sunteți de acord cu termenii și condițiile de mai sus.`;

    setTerms(termsContent);
  }, []);

  return (
    <div className="terms-container">
      <div className="terms-content">
        <ReactMarkdown>{terms}</ReactMarkdown>
      </div>
    </div>
  );
};

export default Terms;